//获取用户信息
import newModuleApi from './newModuleApi'
import innovationApi from './innovationApi'

const getInfo = '/getInfo';
// baseURL='http://localhost:8887/myapp'
//  登录注册接口
const register ='/register';
//获得图片验证码
const getAuthCodeImg ='/api/user/getAuthCodeImg';
//传入验证码验证后获得手机短信验证码
const getphoneCode ='/api/user/getphoneCode';
//登录接口
const login = '/login';
//登录接口
const templogin = '/templogin';
//查询一级目录（小学、初中、高中...）
const recwordCateFirst = '/system/dept/recwordCateFirst';
//获取书籍类型及子书籍接口
const selectBookTreeBCateGoryId = '/system/dept/selectBookTreeBCateGoryId';
//根据年级来查询下面的书籍
const selectBookAllByclass = '/system/dept/selectBookAllByclass';
//根据年级来查询下面的书籍
const setUserInfo = '/system/dept/setUserInfo';
//根据年级来查询下面的书籍
const getUserInfo = '/system/dept/getUserInfo';

const getwordName = '/system/user/profile/dczgetwordName';
const userProfile = '/system/user/profile';
const userProfileAvatar = '/system/user/profile/avatar';
//根据书籍查询总单元信息
const getUnitListByBookId = '/pms/pmsTotalUnit/getUnitListByBookId';
//根据单词id查询单词
const pmsWordDetail = '/pms/pmsWord/detail';
//根据书级id查询单词
const getUnitListByTotalId = '/pms/pmsUnit/getUnitListByTotalId';


//根据单词id查询单词
const getPmsPmsWordsById = '/pms/pmsWords/getById';

//添加到学习内容
const getPmsPmsStudyAdd = '/pms/userWordMap/add';
//添加到学习内容
const getStudyInfo = '/pms/userWordMap/getStudyInfo';
//查询个人词汇列表最新单词
const getStudyByUnitId = '/pms/userWordMap/getStudyByUnitId';
//消息意见反馈
const messageMessageBoardAdd = '/message/messageBoard/add';


//根据单词以及词义搜索单词
const messageMessageBoardgetByWord = '/pms/pmsWords/getByWord';

//收藏单词
const pmsFavoritesUserAdd = '/pms/pmsFavoritesUser/add';

//收藏单词
const pmsFavoritesWordUserAdd = '/pms/pmsFavoritesWord/add';


//删除单词
const deletePmsFavoritesWordWord = '/pms/pmsFavoritesWord/deleteByWord';

//收藏单词
const getPmsFavoritesWordUserAllByUser = '/pms/pmsFavoritesWord/getAllByUser';
//根据收藏夹查询所有单词
const getPmsWordsWordByFavoriteId = '/pms/pmsWords/getWordByFavoriteId';

//根据收藏夹查询所有单词
const getWordByUnId = '/pms/pmsTotalUnit/getWordByUnId';

//根据用户查询所有收藏夹
const getfindListByUserId = '/pms/pmsFavoritesUser/findListByUserId';
//根据用户添加收藏夹
const addpmsFavorites = '/pms/pmsFavorites/addByUser';
const updatepmsFavorites = '/pms/pmsFavorites/update';
const delpmsFavorites = '/pms/pmsFavorites/del';
const uploadFileUrl = 'https://www.wordkillstu.com.cn/backend/common/upload';
// const uploadFileUrl = 'http://192.168.101.113:6098/common/upload';
//根据收藏夹查询所有单词
const getWordAllByFavoriteId = '/pms/pmsWords/getWordAllByFavoriteId';

//根据当前总单元查询子单元以及词汇
const gettreeUnitListByTotalId = '/pms/pmsTotalUnit/gettreeUnitListByTotalId';


//激活码兑换
const activationRedeem = '/pms/activationCode/redeem';
const myBooks = '/pms/activationCode/my-books';
const dataReset = '/api/password/reset';
const getVerifyCode = '/api/password/send-reset-code';
//单词练习  查询对应单词
const pms_practice_getUnitListByBookId = '/pms/practice/getUnitListByBookId';
const pms_practice_submitGrades = '/pms/practice/submitGrades';
export default {
    getInfo:getInfo,
    register: register,
    getAuthCodeImg:getAuthCodeImg,
    getphoneCode:getphoneCode,
    login:login,
    templogin:templogin,
    recwordCateFirst:recwordCateFirst,
    selectBookTreeBCateGoryId:selectBookTreeBCateGoryId,
    selectBookAllByclass:selectBookAllByclass,
    getUnitListByBookId:getUnitListByBookId,
    pmsWordDetail:pmsWordDetail,
    getUnitListByTotalId:getUnitListByTotalId,
    getPmsPmsWordsById:getPmsPmsWordsById,
    getPmsPmsStudyAdd:getPmsPmsStudyAdd,
    messageMessageBoardAdd:messageMessageBoardAdd,
    messageMessageBoardgetByWord:messageMessageBoardgetByWord,
    pmsFavoritesUserAdd:pmsFavoritesUserAdd,
    pmsFavoritesWordUserAdd:pmsFavoritesWordUserAdd,
    getPmsFavoritesWordUserAllByUser:getPmsFavoritesWordUserAllByUser,
    getPmsWordsWordByFavoriteId:getPmsWordsWordByFavoriteId,
    getfindListByUserId:getfindListByUserId,
    addpmsFavorites:addpmsFavorites,
    uploadFileUrl:uploadFileUrl,
    getWordAllByFavoriteId:getWordAllByFavoriteId,
    deletePmsFavoritesWordWord:deletePmsFavoritesWordWord,
    gettreeUnitListByTotalId:gettreeUnitListByTotalId,
    getWordByUnId:getWordByUnId,
    setUserInfo:setUserInfo,
    getUserInfo:getUserInfo,
    pms_practice_submitGrades:pms_practice_submitGrades,
    pms_practice_getUnitListByBookId:pms_practice_getUnitListByBookId,
    getStudyInfo:getStudyInfo,
    getStudyByUnitId:getStudyByUnitId,
    delpmsFavorites:delpmsFavorites,
    updatepmsFavorites:updatepmsFavorites,
    getwordName:getwordName,
    userProfile:userProfile,
    userProfileAvatar:userProfileAvatar,
    getVerifyCode:getVerifyCode,
    dataReset:dataReset,
    activationRedeem:activationRedeem,
    myBooks:myBooks,
    ...newModuleApi,
    ...innovationApi
}


// WEBPACK FOOTER //
// ./src/utils/api.js